import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import KTModal from '../../components/Drawer';
import { updateEntity } from './actions';
import KaiChat from './KaiChat';
import useKaiStore from './useKaiStore';

/**
 * Right-anchored kAI copilot drawer. Mounted once in the app shell (Layout) so
 * the conversation persists across page navigation. Visibility is driven by the
 * global `kai.isDrawerOpen` flag; the house Drawer keeps children mounted while
 * hidden, so KaiChat + its redux state stay alive between opens.
 */
const KaiDrawer = () => {
  useKaiStore();

  const dispatch = useDispatch();
  const isOpen = useSelector(s => s.kai?.isDrawerOpen || false);

  const close = () => dispatch(updateEntity({ isDrawerOpen: false }));

  return (
    <KTModal
      isOpen={isOpen}
      onClose={close}
      anchor="right"
      className="top-0 h-screen w-full max-w-md"
    >
      <KaiChat onClose={close} active={isOpen} />
    </KTModal>
  );
};

export default KaiDrawer;
